import { useEffect, useRef } from 'react';

const CLARITY_TRACKING_CODE = 'ewpxp4x1cf'; // Your specific Clarity project ID

const ClarityLoader = () => {
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    // Check if the Clarity object or script is already present
    // Clarity typically creates a global 'clarity' function and its script src contains 'clarity.ms/tag'
    if (
      typeof window.clarity === 'function' ||
      document.querySelector(`script[src*="clarity.ms/tag/${CLARITY_TRACKING_CODE}"]`)
    ) {
      // console.log('Clarity script already initiated or loaded.');
      scriptLoadedRef.current = true; // Mark as loaded if detected
      return;
    }

    // Prevent script from loading multiple times by this component instance
    if (scriptLoadedRef.current) {
      return;
    }

    const loadClarityScript = () => {
      // Replicate the IIFE logic
      window.clarity =
        window.clarity ||
        function () {
          //eslint-disable-next-line prefer-rest-params
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };

      const t = document.createElement('script');
      t.async = true; // Using boolean true is common in modern JS, 1 also works
      t.src = `https://www.clarity.ms/tag/${CLARITY_TRACKING_CODE}`;
      // Clarity doesn't use a specific ID in the snippet, but we can add one for our tracking if needed
      // t.id = 'clarity-script-loader';

      t.onload = () => {
        // console.log('Clarity script loaded successfully.');
      };

      t.onerror = () => {
        console.error('Failed to load Clarity script.');
        // If script fails to load, reset the ref to allow potential retry if component remounts
        // scriptLoadedRef.current = false;
      };

      const y = document.getElementsByTagName('script')[0];

      if (y && y.parentNode) {
        y.parentNode.insertBefore(t, y);
      } else {
        // Fallback if no script tag is found, append to head or body
        (document.head || document.body).appendChild(t);
        console.warn('ClarityLoader: No script tag found to insert before, appended to head or body.');
      }
    };

    loadClarityScript();
    scriptLoadedRef.current = true; // Mark that an attempt to load has been made

    // Cleanup is generally not required for Clarity as it's a tracking script
    // that initializes and runs.
    return () => {
      // If for some reason you needed to re-trigger on remount (unlikely for Clarity):
      // scriptLoadedRef.current = false;
      // No direct way to "unload" Clarity, it's designed to persist.
    };
  }, []); // Empty dependency array: run once after initial render

  // This component does not render any UI elements
  return null;
};

export default ClarityLoader;
